import * as React from 'react';
import { FormattedMessage, injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import { LinkBack, InfoMessage } from '../components/styled';
import { ContainerWithFooter, ImageContainer } from '../components';
import { PagePath, redirectWithQueryParams } from '../helpers/util';

interface OwnProps {
  intl: any;
}

const mapStateToProps = (state: any) => ({
  locationQuery: state.router.location.query,
});
type StateProps = ReturnType<typeof mapStateToProps>;

type Props = StateProps & OwnProps;

class UserHasIap extends React.Component<Props> {
  render() {
    return (
      <ContainerWithFooter>
        <div className="container">
          <div className="dialog">
            <div className="dialog__content">
              <div className="dialog__content__section">
                <div className="dialog__content__title">
                  <LinkBack onClick={() => redirectWithQueryParams(PagePath.plans, this.props.locationQuery)}
                    className="material-icons">arrow_back</LinkBack>
                  <h1><FormattedMessage id="my_subscription" /></h1>
                </div>
                <div className="dialog__content__body">
                  <InfoMessage>{ this.props.intl.formatMessage({ id: 'text_user_has_iap' }) }</InfoMessage>
                </div>
              </div>
            </div>
            <ImageContainer />
          </div>
        </div>
      </ContainerWithFooter>
    );
  }
}

export default connect<StateProps, OwnProps>(mapStateToProps)(injectIntl(UserHasIap));
